exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media print {\n  .hide-in-print {\n    display: none !important; }\n  .pagebreak {\n    page-break-after: always;\n    clear: both; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/tankers/print/print_tankers.scss
// module id = 1013
// module chunks = 1